export default {
    id:     state => state.id,
    isPlay: state => state.isPlay,
    isShow: state => state.isShow,
    record: state => state.record,
    state:  state => state.state,
};
